import React, {FC, useEffect, useState} from "react";
import { useTask } from '../stateManagement/context';

import { MenuItem, Select} from "@material-ui/core";
import {
    IControlMeasure, IHarm,
    ISeverity
} from "../types/types";


interface ISeveritySelectionProps {
    severities: ISeverity[]
    harm: IHarm
    initial_selection_id: string,
    updateHarm: (harm: IHarm) => void;
}



const SeveritySelection: FC<ISeveritySelectionProps> = ({   severities,
                                                            initial_selection_id,
                                                            harm,
                                                            updateHarm}) => {

    let tasks = useTask()
    
    useEffect(() => {
        if (selected === initial_selection_id) {
            return
        }
        setSelected(initial_selection_id)

    }, [initial_selection_id])

    const [write_access, setWriteAccess] = useState<boolean>(false);

    const  [selected, setSelected] = useState(initial_selection_id);

    useEffect(() => {
        setWriteAccess(tasks.write_access)
    }, [tasks])

    return (
        <div>
            <Select
                style={{fontSize:"11pt"}}
                value={selected}
                disabled={!write_access}
                onChange={(event) => {
                    let selection = event.target.value as string
                    let severity_id = parseInt(selection)

                    if (severity_id){
                        let c  = {...harm};
                        c.severity_id = severity_id
                        updateHarm(c)
                    }
                    setSelected(event.target.value as string)
                }
                }>
                {severities.map((d) => {
                    return <MenuItem value={d.id}>{d.name}</MenuItem>
                })}
            </Select>
        </div>
    );
}

export default SeveritySelection;
